"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9385],{

/***/ 99385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52322);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2784);
/* harmony import */ var client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88121);



/* harmony default export */ __webpack_exports__["default"] = ((0,client_icons_createSvgIcon__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4 5H21C21.6 5 22 5.4 22 6V18C22 18.6 21.6 19 21 19H13V20H15.5C16.1 20 16.5 20.4 16.5 21C16.5 21.6 16.1 22 15.5 22H8.5C7.9 22 7.5 21.6 7.5 21C7.5 20.4 7.9 20 8.5 20H11V19H3C2.4 19 2 18.6 2 18V6C2 5.4 2.4 5 3 5H9.6L8.3 3.7C7.9 3.3 7.9 2.7 8.3 2.3C8.7 1.9 9.3 1.9 9.7 2.3L12 4.6L14.3 2.3C14.7 1.9 15.3 1.9 15.7 2.3C16.1 2.7 16.1 3.3 15.7 3.7L14.4 5ZM4 7V17H20V7H4ZM8.3 12.3L10.3 10.3C10.7 9.9 11.3 9.9 11.7 10.3L13 11.6L14.3 10.3C14.7 9.9 15.3 9.9 15.7 10.3C16.1 10.7 16.1 11.3 15.7 11.7L13.7 13.7C13.5 13.9 13.2 14 13 14C12.8 14 12.5 13.9 12.3 13.7L11 12.4L9.7 13.7C9.3 14.1 8.7 14.1 8.3 13.7C7.9 13.3 7.9 12.7 8.3 12.3Z"
}), "Entertainment"));


/***/ })

}]);